(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["video-popup-buttons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('video-popup-buttons')) {
    class VideoPopupButtons extends HTMLElement {
      connectedCallback() {
        const tpl = this.querySelector('template');
        if (!tpl) return;

        this.modal = tpl.content.firstElementChild.cloneNode(true);
        document.body.appendChild(this.modal);
        this.modalVideo = this.modal.querySelector('.vpb-modal__video');
        this.caption = this.modal.querySelector('.vpb-modal__caption');
        this.closeBtn = this.modal.querySelector('.vpb-modal__close');

        // pass CSS variable for overlay opacity to the modal
        const overlay = this.style.getPropertyValue('--vpb-overlay');
        if (overlay) this.modal.style.setProperty('--vpb-overlay', overlay);

        this.onKey = (e) => { if (e.key === 'Escape') this.close(); };

        this.modal.querySelectorAll('[data-close]').forEach((el) =>
          el.addEventListener('click', () => this.close())
        );

        this.querySelectorAll('.vpb__item').forEach((btn) =>
          btn.addEventListener('click', () => this.open(btn))
        );

        // make sure muted previews autoplay everywhere (iOS/Safari)
        this.querySelectorAll('.vpb__preview').forEach((v) => {
          v.muted = true;
          v.defaultMuted = true;
          const p = v.play();
          if (p && p.catch) p.catch(() => {});
        });
      }

      disconnectedCallback() {
        this.close();
        if (this.modal) this.modal.remove();
      }

      open(btn) {
        this.modalVideo.src = btn.dataset.src;
        this.modalVideo.poster = btn.dataset.poster || '';
        this.caption.textContent = btn.dataset.label || '';
        this.modal.classList.add('is-open');
        document.documentElement.style.overflow = 'hidden';
        document.addEventListener('keydown', this.onKey);

        const p = this.modalVideo.play();
        if (p && p.catch) p.catch(() => {});
        this.closeBtn.focus({ preventScroll: true });
        this.lastBtn = btn;
      }

      close() {
        if (!this.modal || !this.modal.classList.contains('is-open')) return;
        this.modalVideo.pause();
        this.modalVideo.removeAttribute('src');
        this.modalVideo.load();
        this.modal.classList.remove('is-open');
        document.documentElement.style.overflow = '';
        document.removeEventListener('keydown', this.onKey);
        if (this.lastBtn) this.lastBtn.focus({ preventScroll: true });
      }
    }
    customElements.define('video-popup-buttons', VideoPopupButtons);
  }
  } catch(e) { console.error(e); }
})();

})();
